import React from "react";
import { Route, Switch } from "react-router";
import "./i-dashboard-body.style.scss";
import InstituteProfile from "./InstituteProfile/InstituteProfile";
import JobPostDescription from "./JobPostDescription/JobPostDescription";
import JobPostList from "./JobPostList/JobPostList";
import CreateJobPost from "../CreateJobPost/CreateJobPost";
export default function IDashboardBody() {
  return (
    <div className="i-dashboard-body-main">
      <Switch>
        <Route path="/institute/job" component={JobPostDescription} />
        <Route path="/institute/profile" component={InstituteProfile} />
        <Route path="/institute" component={JobPostList} />
      </Switch>
    </div>
  );
}
